module.exports = __webpack_public_path__ + "static/img/logo.5952a1bf.png";